import React from 'react';
export function CostoInvisibleSection() {
  return <section className="bg-[#0F0F0F] py-24 md:py-32 px-6 md:px-12 lg:px-24" data-id="element-11">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center space-y-16" data-id="element-12">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#FFFFFF]" data-id="element-13">
          El problema de una agenda mal diseñada
        </h2>

        <div className="space-y-8 text-xl md:text-2xl text-[#FFFFFF]" data-id="element-14">
          <p data-id="element-15">
            No se ve peligrosa.
            <br data-id="element-16" />
            Se ve como trabajo.
          </p>

          <div className="space-y-2 font-medium text-[#C9A96E]" data-id="element-17">
            <p data-id="element-18">Responder mensajes</p>
            <p data-id="element-19">Atender urgencias</p>
            <p data-id="element-20">Resolver problemas</p>
          </div>

          <p data-id="element-21">
            Y así pasan meses.
            <br data-id="element-22" />
            Trabajando mucho.
            <br data-id="element-23" />
            Creciendo poco.
          </p>
        </div>

        <div className="pt-8 border-t border-[#FFFFFF]/20 w-full" data-id="element-24">
          <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#C9A96E] leading-tight max-w-3xl mx-auto" data-id="element-25">
            Cada hora invertida en trabajo que no genera retorno
            <br data-id="element-26" />
            es crecimiento que tu negocio no está teniendo.
          </p>
        </div>
      </div>
    </section>;
}